import * as v from 'valibot'
import { latestVersionedConfigSchema } from './webchat'

export const webchatIntegrationInputSchema = v.object({
  version: v.optional(v.string()),
  botDisplayName: v.optional(v.string()),
  botAvatarUrl: v.optional(v.string()),
  botDescription: v.optional(v.string()),
  descriptionPhoneNumber: v.optional(
    v.object({
      title: v.optional(v.string()),
      link: v.optional(v.string()),
    })
  ),
  descriptionEmailAddress: v.optional(
    v.object({
      title: v.optional(v.string()),
      link: v.optional(v.string()),
    })
  ),
  descriptionWebsiteUrl: v.optional(
    v.object({
      title: v.optional(v.string()),
      link: v.optional(v.string()),
    })
  ),
  termsConditionsUrl: v.optional(
    v.object({
      title: v.optional(v.string()),
      link: v.optional(v.string()),
    })
  ),
  privacyPolicyUrl: v.optional(
    v.object({
      title: v.optional(v.string()),
      link: v.optional(v.string()),
    })
  ),
  botComposerPlaceholder: v.optional(v.string()),
  showPoweredByBotpress: v.optional(v.boolean()),
  // additionalStylesheet: v.optional(v.string()), // TODO: Remove this in November 2025
  additionalStylesheetUrl: v.optional(v.string()),
  allowedOrigins: v.optional(v.array(v.string())),
  primaryColor: v.optional(v.string()),
  borderRadiusScale: v.optional(v.number()),
  themeMode: v.optional(v.picklist(['light', 'dark'])),
  variant: v.optional(v.picklist(['solid', 'soft'])),
  headerVariant: v.optional(v.picklist(['solid', 'glass'])),
  feedbackEnabled: v.optional(v.boolean()),
  soundEnabled: v.optional(v.boolean()),
  fontFamily: v.optional(v.string()),
  showPoweredBy: v.optional(v.boolean()),
  allowFileUpload: v.optional(v.boolean()),
  adminSecret: v.optional(v.string()),
})

export type WebchatIntegrationInput = v.InferOutput<typeof webchatIntegrationInputSchema>

export const webchatConfigToWebchatIntegrationInput = v.pipe(
  latestVersionedConfigSchema,
  v.transform((webchatConfig) => {
    return {
      version: webchatConfig.version,
      botDisplayName: webchatConfig.botName,
      botAvatarUrl: webchatConfig.botAvatar,
      botDescription: webchatConfig.botDescription,
      fabImage: webchatConfig.fabImage,
      descriptionPhoneNumber: webchatConfig.phone,
      descriptionEmailAddress: webchatConfig.email,
      descriptionWebsiteUrl: webchatConfig.website,
      termsConditionsUrl: webchatConfig.termsOfService,
      privacyPolicyUrl: webchatConfig.privacyPolicy,
      botComposerPlaceholder: webchatConfig.composerPlaceholder,
      additionalStylesheet: webchatConfig.additionalStylesheet,
      additionalStylesheetUrl: webchatConfig.additionalStylesheetUrl,
      primaryColor: webchatConfig.color,
      borderRadiusScale: webchatConfig.radius,
      themeMode: webchatConfig.themeMode,
      variant: webchatConfig.variant,
      headerVariant: webchatConfig.headerVariant,
      feedbackEnabled: webchatConfig.feedbackEnabled,
      soundEnabled: webchatConfig.soundEnabled,
      fontFamily: webchatConfig.fontFamily,
      footer: webchatConfig.footer,
      allowFileUpload: webchatConfig.allowFileUpload,
      storageLocation: webchatConfig.storageLocation,
      embeddedChatId: webchatConfig.embeddedChatId,
      toggleChatId: webchatConfig.toggleChatId,
      adminSecret: webchatConfig.adminSecret,
      proactiveMessageEnabled: webchatConfig.proactiveMessageEnabled,
      proactiveBubbleMessage: webchatConfig.proactiveBubbleMessage,
      proactiveBubbleTriggerType: webchatConfig.proactiveBubbleTriggerType,
      proactiveBubbleDelayTime: webchatConfig.proactiveBubbleDelayTime,
    }
  })
)
